import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';

import Head from '../../components/Partials/Head/Head';
import Auxiliary from '../../hoc/Auxiliary';
import ServiceBanner from '../../components/ServiceBanner/ServiceBanner';
import ServiceSection from '../../components/ServiceSection/ServiceSection';
import TextGroup from '../../components/TextGroup/TextGroup';
import CTA from '../../components/CTA/CTA';
class Outsourcing extends Component {

  render() {
    return (
      <Auxiliary>
        <Head {...this.props} id="outsourcing" />
        <ServiceBanner {...this.props} page="outsourcing" />
        <ServiceSection noPadBottom {...this.props} page="outsourcing" section="benefits">
          <TextGroup {...this.props} page="outsourcing" section="benefits" />
        </ServiceSection>
        <ServiceSection noTitle {...this.props} page="outsourcing">
          <CTA noBG {...this.props} />
        </ServiceSection>
      </Auxiliary>
    )
  }
}

export default withTranslation()(Outsourcing);